import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type SiteHasDependentsErrorOptions = {
  site: ObjectId;
  domains: ObjectId[];
  ipnsRecords: ObjectId[];
};

export class SiteHasDependentsError extends FleekError<SiteHasDependentsErrorOptions> {
  public name = 'SiteHasDependentsError';

  toString = () => {
    const dependentsInfo: string[] = [];

    if (this.data.domains.length > 0) {
      dependentsInfo.push(`${this.data.domains.length} domains`);
    }

    if (this.data.ipnsRecords.length > 0) {
      dependentsInfo.push(`${this.data.ipnsRecords.length} IPNS records`);
    }

    return `Site has assigned ${dependentsInfo}. You have to delete them first.`;
  };
}
